export const toTitleCase = (str) => {
    if (str === null || str === false) {
        return;
    }
    return str?.replace(/\w\S*/g, function (txt) {
        return txt?.charAt(0)?.toUpperCase() + txt?.substr(1)?.toLowerCase();
    });
};
